import {
    apiRequest,
    rekapSyncPresensi,
    rekapketidakhadiranexport
} from "../../../../../services/adapters/kepegawaian/rekapKetidakhadiranService"

class IndexRepository {

    fetchSync = async (query) => {
        return await apiRequest("get", rekapSyncPresensi, {
            params: query
        }, true)
    }

    fetchPresensiKetidakhadiranExport = async (query) => {
        return await apiRequest("get", rekapketidakhadiranexport, {
            params: query
        }, true)
    }
    
}

export default IndexRepository